import { useState, useContext } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles/dashboard.css";
import DashboardSidebar from "./DashboardSidebar";
import DashboardHeader from "./DashboardHeader";
import { AuthContext } from "../../Context/AuthContext";

const DashboardLayout = ({ navItems, footerLinks, showVerificationBadge = false, shellClassName = "" }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, Logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    Logout();
    navigate("/login");
  };

  const greeting = user?.first_name
    ? `Welcome back, ${user.first_name}`
    : "Welcome back";

  const badge =
    showVerificationBadge && user
      ? {
          verified: user.isInfoVerify,
          text: user.isInfoVerify ? "Verified seller" : "Verification pending",
        }
      : null;

  return (
    <div className={`dashboard-shell${shellClassName ? ` ${shellClassName}` : ""}`}>
      <DashboardSidebar
        navItems={navItems}
        footerLinks={footerLinks}
        sidebarOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onLogout={handleLogout}
      />
      <div className="dashboard-main">
        <DashboardHeader
          greeting={greeting}
          badge={badge}
          onMenuClick={() => setSidebarOpen(true)}
        />
        <main className="dashboard-content">
          <Outlet />
        </main>
      </div>
      <ToastContainer position="top-right" autoClose={4000} className="stex-toast" />
    </div>
  );
};

export default DashboardLayout;
